export const doResultListTracking = (jsonData) => {
	var pageType = null;
	var dataObject = {};
	var dataPageObject = {};
	if (jsonData.search == 'Y') {
		var pageId = 'SEARCH: Results Successful';
		dataPageObject.page = {
			pageId: pageId,
			RealSearch: 'Y',
			categoryId: '-10005',
			searchResultsCount: jsonData.productCount,
			searchTerm: jsonData.searchTerm,
		};
		adobeTracking.setPageContentInfo(dataPageObject);
		pageType = 'search';
	} else if (jsonData.category == 'Y') {
		if (!window.alreadyTracked) {
			var color = '';
			if ($('h1').data('seocolor')) {
				color = $('h1').data('seocolor');
			}
			dataPageObject.page = {
				pageId: jsonData.pageId,
				extraparms: jsonData.extraparms,
				priceReduced: jsonData.priceReduction,
				seoColor: color,
			};
			adobeTracking.setPageContentInfo(dataPageObject);
		}
		pageType = 'category';
	} else if (jsonData.brand == 'Y') {
		var pageId = jsonData.manufacturer + ' Landing Page';
		if (!window.alreadyTracked) {
			dataPageObject.page = {
				pageId: pageId,
				extraparms: 'Brand',
				categoryId: -10032,
			};
			adobeTracking.setPageContentInfo(dataPageObject);
		}
		pageType = 'brand';
	}
	if (!window.alreadyTracked) {
		window.productsLoaded = true;
		adobeTracking.setPageType(pageType, dataObject);
	} else {
		adobeTracking.addProducts(jsonData);
	}
	window.alreadyTracked = false;
};
